import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackbarCtx = createContext({ enqueueSnackbar: () => {} });

export function useSnackbar() {
  return useContext(SnackbarCtx);
}

export default function SnackbarProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('info');

  const enqueueSnackbar = useCallback((msg, opts = {}) => {
    setMessage(msg);
    setSeverity(opts.variant || 'info');
    setOpen(true);
  }, []);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const value = useMemo(() => ({ enqueueSnackbar }), [enqueueSnackbar]);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const orig = window.alert;
      window.alert = (msg) => enqueueSnackbar(String(msg));
      return () => { window.alert = orig; };
    }
  }, [enqueueSnackbar]);

  return (
    <SnackbarCtx.Provider value={value}>
      {children}
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarCtx.Provider>
  );
}
